import { joinDataTestId } from "@/constants/data-test-ids.utils";

export const weekChipDataTestIds = {
  component: "week-chip" as const,
  button: (weekId: number | string): string => joinDataTestId(weekChipDataTestIds.component, "button", String(weekId)),
  selectedBadge: (weekId: number | string): string =>
    joinDataTestId(weekChipDataTestIds.component, "selected-badge", String(weekId)),
  weekLabel: (weekId: number | string): string =>
    joinDataTestId(weekChipDataTestIds.component, "week-label", String(weekId)),
  dateRange: (weekId: number | string): string =>
    joinDataTestId(weekChipDataTestIds.component, "date-range", String(weekId)),
  availabilityIndicator: (weekId: number | string): string =>
    joinDataTestId(weekChipDataTestIds.component, "availability-indicator", String(weekId)),
  availabilityLabel: (weekId: number | string): string =>
    joinDataTestId(weekChipDataTestIds.component, "availability-label", String(weekId)),
  starsRating: (weekId: number | string): string =>
    joinDataTestId(weekChipDataTestIds.component, "stars-rating", String(weekId)),
};
